import type { IconDefinition } from '../index.tsx';

export const iconCalendar: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconCalendar',
  icon: [16, 16, [], '', 'M6 0H3V2H1V5H15V2H13V0H10V2H6V0Z M15 7H1V15H15V7Z'],
};
